import React from 'react';
import { motion } from 'framer-motion';
import { FAQ } from './FAQ';
const SHOPIFY_URL = 'https://tuserenequilibrio.com/cart/51604831895873:1';
export function PricingCTA() {
  const handleComprarClick = () => {
    try {
      const fbq = (window as unknown as {
        fbq?: (...args: unknown[]) => void;
      }).fbq;
      if (typeof fbq === 'function') {
        fbq('track', 'AddToCart', {
          content_name: '¿ESTÁS LISTO PARA JUGAR?',
          content_ids: ['51604831895873'],
          content_type: 'product',
          value: 6.39,
          currency: 'USD'
        });
      }
    } catch (err) {
      console.warn('[fbpixel] AddToCart failed:', err);
    }
    // Open synchronously inside the click handler so popup blockers
    // don't kill it. _blank keeps this page (and the pixel) alive
    // so the AddToCart request completes in the background.
    window.open(SHOPIFY_URL, '_blank', 'noopener,noreferrer');
  };
  return <section className="pt-8 md:pt-12 pb-16 md:pb-32 bg-matrix-black relative overflow-hidden px-4" data-id="element-182">
      {/* Layered halo behind the decision block — gold core + green ambient + bottom rise */}
      <div className="pointer-events-none absolute inset-0 z-0 bg-[radial-gradient(ellipse_at_bottom,_var(--tw-gradient-stops))] from-matrix-green/10 via-matrix-black to-matrix-black opacity-60" data-id="element-183"></div>
      <div className="pointer-events-none absolute left-1/2 top-[18%] z-0 h-[60vh] w-[60vh] -translate-x-1/2 rounded-full bg-[radial-gradient(circle,_rgba(216,184,120,0.12)_0%,_rgba(0,255,65,0.05)_45%,_transparent_72%)] blur-3xl" data-id="element-184"></div>
      {/* Soft transition from the section above */}
      <div className="pointer-events-none absolute inset-x-0 top-0 z-0 h-24 bg-gradient-to-b from-matrix-black to-transparent" data-id="element-185"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-186">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-187">
          <div id="precio" className="scroll-mt-8" data-id="element-188">
            {/* Premium decision card */}
            <div className="relative mx-auto max-w-lg overflow-hidden rounded-2xl border border-[rgba(216,184,120,0.28)] bg-matrix-dark/60 backdrop-blur-sm px-6 md:px-10 py-9 md:py-12 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.9),0_0_50px_-20px_rgba(216,184,120,0.4)]" data-id="element-189">
              {/* Soft top light line */}
              <div className="pointer-events-none absolute top-0 left-0 h-px w-full bg-gradient-to-r from-transparent via-[rgba(216,184,120,0.6)] to-transparent" data-id="element-190"></div>

              <div className="mb-5 flex items-end justify-center gap-3" data-id="element-191">
                <span className="text-matrix-white/45 line-through text-lg md:text-xl font-light pb-2" data-id="element-192">
                  $19.99
                </span>
                <span className="font-cinzel text-5xl md:text-6xl font-bold leading-none" style={{
                color: '#e6c48f',
                textShadow: '0 0 22px rgba(216,184,120,0.5), 0 0 50px rgba(216,184,120,0.2)'
              }} data-id="element-193">
                  $9,99
                </span>
              </div>
              <p className="text-xs md:text-sm uppercase tracking-[0.2em] mb-8" style={{
              color: 'rgba(216,184,120,0.75)'
            }} data-id="element-194">
                Acceso inmediato · Precio especial por tiempo limitado
              </p>

              <motion.button type="button" onClick={handleComprarClick} whileHover={{
              scale: 1.04,
              boxShadow: '0 0 38px rgba(216,184,120,0.55)'
            }} whileTap={{
              scale: 0.96
            }} style={{
              backgroundImage: 'linear-gradient(135deg, #e8cf9a 0%, #d8b878 50%, #c4a05f 100%)',
              color: '#0a0f0a'
            }} className="inline-block w-full sm:w-auto whitespace-nowrap font-inter font-bold text-base md:text-xl px-6 sm:px-12 md:px-14 py-3.5 md:py-5 rounded-md uppercase tracking-[0.06em] sm:tracking-[0.12em] transition-all duration-300 shadow-[0_0_28px_rgba(216,184,120,0.4)] border border-[rgba(255,245,220,0.4)] cursor-pointer outline-none" data-id="element-195">
                QUIERO ACCEDER AHORA
              </motion.button>

              <p className="mt-6 text-matrix-white/55 text-xs md:text-sm tracking-[0.15em] uppercase font-light" data-id="element-196">
                Formato Digital · Entrega Inmediata
              </p>

              {/* Trust microbadges */}
              <div className="mt-7 flex flex-wrap items-center justify-center gap-2.5" data-id="element-197">
                {['PDF digital', 'Acceso inmediato', 'Compra segura'].map(badge => <span key={badge} className="inline-flex items-center gap-1.5 rounded-full border border-matrix-green/25 bg-matrix-green/[0.06] px-3 py-1.5 font-inter text-[10px] md:text-[11px] tracking-[0.15em] uppercase text-matrix-white/65" data-id="element-198">
                      <span className="h-1.5 w-1.5 rounded-full" style={{
                  backgroundColor: '#d8b878'
                }} data-id="element-199"></span>
                      {badge}
                    </span>)}
              </div>
            </div>

            {/* FAQ accordion — between the offer and the legal block */}
            <FAQ data-id="element-200" />

            <motion.div initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="mt-12 md:mt-16 max-w-md mx-auto border-t border-matrix-green/15 pt-6 md:pt-8 space-y-[6px]" data-id="element-201">
              <h3 className="font-cinzel text-matrix-cream md:text-base tracking-wider mb-3 md:mb-4 text-[9px]" data-id="element-202">
                Compra segura y acceso claro
              </h3>
              <ul className="space-y-2 md:space-y-2.5 text-matrix-white/70 text-xs md:text-sm font-light leading-relaxed" data-id="element-203">
                <li className="text-[9px]" data-id="element-204">
                  Recibirás tu ebook en PDF al completar el pago.
                </li>
                <li className="text-[9px]" data-id="element-205">
                  Revisa tu bandeja principal, Spam o Promociones si no ves el
                  correo de acceso.
                </li>
                <li className="text-[9px]" data-id="element-206">
                  Al tratarse de un producto digital de entrega inmediata, la
                  compra no es reembolsable.
                </li>
              </ul>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}